export const getColumnDefaultSortDirection = (columnName: string) => {
  switch (columnName) {
    case "location.name":
      return "asc";
    case "created_at":
      return "desc";
    case "start_date":
      return "asc";
    case "end_date":
      return "desc";
    case "status":
      return "asc";
    default:
      return "asc";
  }
};
